// extracted by mini-css-extract-plugin
export default {"title":"Title_title__bKjsd","h1":"Title_h1__jGyF1","h2":"Title_h2__kd5xT","h3":"Title_h3__H+kBb","h4":"Title_h4__B66bF","h5":"Title_h5__8EXu1","h6":"Title_h6__fN-Sm"};